import React from 'react';
import PropTypes from 'prop-types';

import CancelEvent from './CancelEvent';
import RescheduleEvent from './RescheduleEvent';
import AcceptRescheduleRequest from './AcceptRescheduleRequest';
import AcceptCancelRequest from './AcceptCancelRequest';

const Popup = (props) => {
  const {model, setModel, event, handleCancelEvent, handleRescheduleEvent} = props;

  const popModelGenerator = React.useCallback(() => {
    const closeModel = () => {
      setModel(null);
    };

    let popModel = null;
    switch (model) {
      case 'CANCEL':
        popModel = <CancelEvent
          closeModel={closeModel}
          event={event}
          onCancelEvent={handleCancelEvent}
        />;
        break;
      case 'RESCHEDULE':
        popModel = <RescheduleEvent
          closeModel={closeModel}
          event={event}
          onRescheduleEvent={handleRescheduleEvent}
        />;
        break;
      case 'ACCEPT_RESCHEDULE_REQUEST':
        popModel = <AcceptRescheduleRequest
          closeModel={closeModel}
          event={event}
          onRescheduleEvent={handleRescheduleEvent}
        />;
        break;
      case 'ACCEPT_CANCEL_REQUEST':
        popModel = <AcceptCancelRequest
          closeModel={closeModel}
          event={event}
          onCancelEvent={handleCancelEvent}
        />;
        break;
      default:
        break;
    }
    return popModel;
  }, [model, event]);

  return (
    <>
      {popModelGenerator()}
    </>
  );
};

Popup.propTypes = {
  model: PropTypes.string,
  setModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  handleCancelEvent: PropTypes.func.isRequired,
  handleRescheduleEvent: PropTypes.func.isRequired,
};

export default Popup;
